import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import _ from 'lodash';
import TestModeBubble from './../TestModeBubble/TestModeBubble';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import AddVisualStateForm from '../../AddVisualStateForm/AddVisualStateForm';
import getNodeKey from '../../../../../services/mini/getKeyNode';
import getConversationId from '../../../../../services/mini/getConversationId';
import DialogItemIcon from './../DialogItemIcon/DialogItemIcon';

class DialogItem extends React.Component {
    constructor(props, context) {
        super(props, context);

        const {
            node,
            expectedResponsesAreShownGlobally,
            expectedResponsesAreOpenedForDialogItem
        } = this.props;

        this.state = {
            refreshing: false,
            showExpectedResponses: expectedResponsesAreOpenedForDialogItem || expectedResponsesAreShownGlobally
        };

        this.testModeBubbleEl = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const {
            expectedResponsesAreShownGlobally,
            expectedResponsesAreOpenedForDialogItem,
            node
        } = this.props;

        if (prevProps.expectedResponsesAreShownGlobally !== expectedResponsesAreShownGlobally) {
            this.setState({
                showExpectedResponses: expectedResponsesAreShownGlobally
            });
        }
        if (prevProps.expectedResponsesAreOpenedForDialogItem !== expectedResponsesAreOpenedForDialogItem) {
            this.setState({
                showExpectedResponses: expectedResponsesAreOpenedForDialogItem || expectedResponsesAreShownGlobally
            });
        }
    }

    refreshDialogItem = () => {
        const { node, conversationId, refreshPhrases, dialogTree } = this.props;
        this.setState({ refreshing: true });
        refreshPhrases({
            conversationId,
            node,
            dialogTree
        }).then(() => {
            this.setState({ refreshing: false });
        });
    }

    deleteDialogItem = () => {
        const { node, conversationId, deleteDialogItem, dialogTree } = this.props;
        deleteDialogItem({
            conversationId,
            node,
            dialogTree,
        });
    }

    addVisualState = () => {
        const { node, dialog, conversationId, addVisualState, dialogTree } = this.props;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <AddVisualStateForm
                        onClose={onClose}
                        onSave={(visualState) => {
                            addVisualState({
                                dialog,
                                visualState,
                                curNode: node,
                                conversationId,
                                dialogTree,
                                direction: 'before'
                            });
                        }}
                    />
                );
            }
        });
    }

    addExpectedResponse = () => {
        const {
            node,
            conversationId,
            addExpectedResponse,
            showExpectedResponsesForDialogItem,
            dialogTree,
        } = this.props;

        this.setState({ showExpectedResponses: true });

        showExpectedResponsesForDialogItem({ id: node.id });

        if (!node?.visualProperties?.expectedResponses) {
            addExpectedResponse({
                conversationId,
                node,
                dialogTree,
                response: '',
                condition: 'or'
            }).then(() => {
                this.openEditModeForExpectedResponseBubble();
            });
        } else {
            this.openEditModeForExpectedResponseBubble();
        }
    }

    openEditModeForExpectedResponseBubble = () => {
        if (this.testModeBubbleEl.current) {
            if (this.testModeBubbleEl.current.requestTestModeBubbleEl.current) {
                if (this.testModeBubbleEl.current.requestTestModeBubbleEl.current.expectedResponsesTestModeBubbleEl.current) {
                    this.testModeBubbleEl.current.requestTestModeBubbleEl.current.expectedResponsesTestModeBubbleEl.current.openEditMode();
                }
            }
        }
    }

    pasteAllExpectedResponses = () => {
        const {
            node,
            conversationId,
            pasteAllExpectedResponses,
            showExpectedResponsesForDialogItem,
            dialogTree,
            copiedExpectedResponses
        } = this.props;

        this.setState({ showExpectedResponses: true });

        showExpectedResponsesForDialogItem({ id: node.id });

        pasteAllExpectedResponses({
            conversationId,
            node,
            dialogTree,
            copiedExpectedResponses
        });
    }

    addNodeBefore = () => {
        this.props.onAddNodeBefore();
    }

    render() {
        const { node, copiedExpectedResponses } = this.props;
        const {
            refreshing,
            showExpectedResponses
        } = this.state;
        const { responseForUi, request } = node;
        const isVisualState = request?.visualState;

        return (
            <div className={`dialog__item ${refreshing && 'disabled'} ${isVisualState && 'visual-state'}`}>
                <div className="dialog__item-actions-top">
                    <div className="dialog__item-actions-top__left-part">
                        <DialogItemIcon
                            collapsedSize={20}
                            expandedSize={94}
                            label="Add request"
                            reversed={true}
                            onClick={this.addNodeBefore} >
                            <i className="icon icon-alan-test-plus add-before" />
                        </DialogItemIcon>
                    </div>
                    <div className="dialog__item-actions-top__right-part">
                        <DialogItemIcon
                            collapsedSize={20}
                            expandedSize={114}
                            onClick={this.addVisualState}
                            label="Add Visual State">
                            <i className="icon icon-alan-test-vision add-vs" />
                        </DialogItemIcon>
                    </div>
                </div>
                <div className="dialog__item-actions-right">
                    {!isVisualState && <DialogItemIcon
                        collapsedSize={25}
                        expandedSize={204}
                        onClick={this.addExpectedResponse}
                        label="Add expected response">
                        <i className="icon icon-alan-test-edit add-expected-response" />
                    </DialogItemIcon>}
                    {(!isVisualState && copiedExpectedResponses !== null) && <DialogItemIcon
                        collapsedSize={25}
                        expandedSize={204}
                        onClick={this.pasteAllExpectedResponses}
                        label="Paste expected responses">
                        <i className="icon icon-alan-duplicate copy-expected-response" />
                    </DialogItemIcon>}
                    <DialogItemIcon
                        collapsedSize={25}
                        expandedSize={84}
                        onClick={this.deleteDialogItem}
                        label="Delete">
                        <i className="icon icon-alan-test-delete" />
                    </DialogItemIcon>
                </div>
                <TestModeBubble
                    ref={this.testModeBubbleEl}
                    key={getNodeKey(node)}
                    data={request}
                    node={node}
                    showExpectedResponses={showExpectedResponses}
                    type="request" />
                {responseForUi.map((responseItem, responseItemInd) => {
                    return <TestModeBubble
                        key={responseItemInd}
                        data={responseItem}
                        node={node}
                        type="response" />;
                })}
                <TestModeBubble
                    ref={this.testModeBubbleEl}
                    key={`${getNodeKey(node)}-expected-response`}
                    data={request}
                    node={node}
                    showExpectedResponses={showExpectedResponses}
                    type="expected-response" />
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }, { node }) {
    return {
        dialogTree: testMode.dialogTree,
        expectedResponsesAreShownGlobally: testMode.expectedResponsesAreShownGlobally,
        conversationId: getConversationId(projectsInfo.currentProject.conversations),
        expectedResponsesAreOpenedForDialogItem: !!testMode.dialogItemsWithOpenedExpectedResponses[node.id],
        copiedExpectedResponses: testMode.copiedExpectedResponses
    };
}

function mapDispatchToProps(dispatch) {
    return {
        deleteDialogItem: (param) => dispatch(actions.deleteDialogItem(param)),
        refreshPhrases: (param) => asyncDispatch(actions.refreshPhrases, dispatch, param),
        addVisualState: (param) => asyncDispatch(actions.addVisualState, dispatch, param),
        addExpectedResponse: (param) => asyncDispatch(actions.addExpectedResponse, dispatch, param),
        pasteAllExpectedResponses: (param) => asyncDispatch(actions.pasteAllExpectedResponses, dispatch, param),
        showExpectedResponses: () => dispatch(actions.showExpectedResponses()),
        hideExpectedResponses: () => dispatch(actions.hideExpectedResponses()),
        showExpectedResponsesForDialogItem: (param) => dispatch(actions.showExpectedResponsesForDialogItem(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogItem);

